module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEdSURBVHgB7djhDYJADIbhYvivo7CCG7ACIziBOoGjyAY6AiM4AhOA/Yg1ooBwhLM19yRE+GPemBPKEQVB4FVEM6RpmtR1fWq+KIqyPM9vtLCYHD1iL3y6wTWf7/kjo4WtyMF7rE+Tg3tiC14SO/Jg0hoeiN3y+i3Jg9HBGmJhVLCWWPgarCkWBoO1xUJvsMZY6AzWGgsfwZpjoRWsPRaewRZioQm2EgvRwCBT8KErlueVmGPP1D11JaQMflhMa95HxBnKGOvUyJIoufVo708nJ6Zua8LUg0OYejQLU8OPMDVeClMDvDD1iiRMvYQKU6/5wtRGivh19OS9NY5q4qg9GCVVVR3IA6fdy65ovl6TB07B8BJ9xYHRj4Ig+D93HR8TPvioSkcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-arrow.png
// module id = Kiuh
// module chunks = 0